/* Site metrics (T-545, plan shared/plans/site-metrics.md; Chase YES 2026-10-27, 1564758150438195273).
   Anonymous shop steps -> members.byrdgang.com/api/metrics with sendBeacon (text/plain JSON, one event each).
   On only with the theme setting 'site_metrics_enabled' (OFF by default; off = rollback).
   Sends only when Shopify analytics processing is allowed AND the visitor's Shopify region is US; otherwise nothing is
   sent and no visit id is made. Never reads lm, referral codes, click ids, names or emails; the referrer is classified
   here and never sent. Automated browsers (navigator.webdriver) send nothing; QA's init script sets
   window.BG_METRICS_QA=true to send with a 'qa-' visit id instead (reports exclude qa-).
   Unpublished themes only: ?bg_metrics_debug=1 prints the gate decision and every event (console + BG_METRICS.log).
   Pages call window.BG_METRICS.send(event, fields); a stub in snippets/bg-site-metrics.liquid queues calls made before
   this file runs. Pure helpers are unit-tested (tests/site-metrics.test.cjs). */
(function(root,factory){
  const api=factory();
  if(typeof module==='object'&&module.exports)module.exports=api;
  else api.boot(root);
})(typeof window==='undefined'?globalThis:window,function(){
  'use strict';
  const VISIT_KEY='bg-metrics-visit',TRAY_KEY='bg-metrics-tray',ONCE_KEY='bg-metrics-once',UTM_KEY='bg-metrics-utm';
  const VISIT_MS=30*86400000,MAX_SEQ=2000;
  const UTM={listmonk:'listmonk',fb:'fb',facebook:'fb',ig:'ig',instagram:'ig',google:'google',tiktok:'tiktok',qa:'qa'};
  const FIELDS=['product','size','fit','seat','target','entry','page_type','tab','filter_type','filter_value','ok','stage',
    'fail_class','load_bucket','src','kind','via','attempt','flag','tray_id'];
  const SIZE={XXL:'2XL',XXXL:'3XL'};

  function uuid(c){
    if(c&&c.randomUUID)return c.randomUUID();
    const b=c.getRandomValues(new Uint8Array(16));b[6]=b[6]&15|64;b[8]=b[8]&63|128;
    const h=[...b].map(x=>x.toString(16).padStart(2,'0')).join('');
    return `${h.slice(0,8)}-${h.slice(8,12)}-${h.slice(12,16)}-${h.slice(16,20)}-${h.slice(20)}`;
  }
  // Fixed list only: anything else (free text, an email address) is 'other'; no utm_source = 'direct'.
  function utmBucket(v){v=String(v||'').trim().toLowerCase();return v?UTM[v]||'other':'direct';}
  function loadBucket(ms){return ms<1000?'lt1s':ms<3000?'1to3s':ms<10000?'3to10s':'gt10s';}
  function failClass(e){
    const n=e&&e.name;
    if(n==='TimeoutError'||n==='AbortError')return 'timeout';
    if(n==='SyntaxError')return 'parse';
    return /status|availability|cart/.test(String(e&&e.message||''))?'http':'other';
  }
  // Where the shopper came from, decided here; only the class leaves the device.
  // page 'picker': product param = pdp, a saved tray on a new visit = resume, then the previous page on this site.
  function classifyEntry(referrer,host,{page,seeded,returning}={}){
    if(page==='picker'&&seeded)return 'pdp';
    if(page==='picker'&&returning)return 'resume';
    let u;try{u=new URL(referrer);}catch{return 'direct';}
    if(u.host!==host)return 'other';
    const p=u.pathname;
    if(p==='/'||p==='')return 'home';
    if(/^\/search(\/|$)/.test(p))return 'search';
    if(/^\/products\//.test(p))return page==='picker'?'pdp':'other';
    if(/^\/collections\/all\/?$/.test(p)&&/view=pick3/.test(u.search))return 'other';
    if(/^\/collections\//.test(p))return 'collection';
    // The picker is linked from the header on every other page.
    return page==='picker'&&!/^\/cart(\/|$)/.test(p)?'header':'other';
  }
  // Only allow-listed fields, each a plain value; sizes as the server spells them; handles/filter values as slugs.
  function clean(fields){
    const out={};
    for(const k of FIELDS){
      let v=fields&&fields[k];
      if(v===undefined||v===null||v==='')continue;
      if(typeof v==='string'){
        if(k==='size'){v=v.toUpperCase();v=SIZE[v]||v;}
        else if(k==='product'||k==='filter_value')v=v.toLowerCase().replace(/[^a-z0-9-]+/g,'-').replace(/^-+|-+$/g,'').slice(0,40);
        if(!v)continue;
        v=v.slice(0,100);
      }else if(typeof v!=='number'&&typeof v!=='boolean')continue;
      out[k]=v;
    }
    return out;
  }
  // The visit id: fixed 30 days from creation, never renewed or linked to an earlier one. qa runs get their own qa- id.
  function visitFor(saved,now,qa,c){
    const ok=saved&&typeof saved.id==='string'&&now-saved.created<VISIT_MS&&now>=saved.created&&saved.id.startsWith('qa-')===!!qa&&Number.isInteger(saved.seq);
    return ok?saved:{id:(qa?'qa-':'')+uuid(c),created:now,seq:0};
  }
  function regionUS(region){return /^US/.test(String(region||''));}

  function boot(win){
    if(!win||!win.document||win.__bgMetricsBooted)return;win.__bgMetricsBooted=true;
    const doc=win.document,stub=win.BG_METRICS,queued=stub&&Array.isArray(stub.q)?stub.q:[];
    let cfg=null;try{cfg=JSON.parse(doc.getElementById('bg-site-metrics')?.textContent||'null');}catch{}
    let product=null;try{product=JSON.parse(doc.getElementById('bg-site-metrics-product')?.textContent||'null');}catch{}
    const get=(s,k)=>{try{return JSON.parse(win[s].getItem(k)||'null');}catch{return null;}};
    const put=(s,k,v)=>{try{win[s].setItem(k,JSON.stringify(v));}catch{}};
    const params=new URLSearchParams(win.location.search);
    const role=win.Shopify&&win.Shopify.theme&&win.Shopify.theme.role;
    let debug=false;
    if(role==='unpublished'){
      if(params.get('bg_metrics_debug')==='1')put('sessionStorage','bg-metrics-debug',1);
      if(params.get('bg_metrics_debug')==='0')put('sessionStorage','bg-metrics-debug',0);
      debug=get('sessionStorage','bg-metrics-debug')===1;
    }
    const log=[];
    const note=(what,data)=>{if(!debug)return;log.push({what,...data});try{win.console.info('[bg-metrics]',what,data);}catch{}};
    const qa=win.BG_METRICS_QA===true;
    const bot=!qa&&!!(win.navigator&&win.navigator.webdriver);
    let state=cfg&&cfg.url?'pending':'off',queue=[];

    // utm_source of the landing page, kept for this browser session.
    let utm=get('sessionStorage',UTM_KEY);
    if(params.has('utm_source')||!utm){utm=utmBucket(params.get('utm_source'));put('sessionStorage',UTM_KEY,utm);}

    function emit(event,fields){
      const now=Date.now(),v=visitFor(get('localStorage',VISIT_KEY),now,qa,win.crypto);
      if(v.seq>=MAX_SEQ)return;
      v.seq++;put('localStorage',VISIT_KEY,v);
      const body={visit_id:v.id,seq:v.seq,event,utm,device:win.matchMedia&&win.matchMedia('(max-width:767px)').matches?'mobile':'desktop',...clean(fields)};
      note('event',body);
      try{win.navigator.sendBeacon(cfg.url,new win.Blob([JSON.stringify(body)],{type:'text/plain'}));}catch{}
    }
    function send(event,fields){
      if(state==='on')return emit(event,fields);
      if(state==='pending'){if(queue.length<100)queue.push([event,fields]);return;}
      note('not sent',{event});
    }
    function settle(on,why){
      if(state!=='pending')return;
      state=on?'on':'off';note('gate',{decision:state,...why});
      // Off: nothing of ours stays on the device (no visit id, tray id or once-list).
      if(!on){try{win.localStorage.removeItem(TRAY_KEY);win.localStorage.removeItem(ONCE_KEY);}catch{}}
      const q=queue;queue=[];if(on)q.forEach(([e,f])=>emit(e,f));
    }
    // Consent + US gate (plan: analyticsProcessingAllowed() AND region US, else OFF). Bots never send.
    if(state==='pending'){
      if(bot)settle(false,{bot:true});
      else{
        let done=false;
        const ask=()=>{if(done)return;done=true;
          try{const c=win.Shopify.customerPrivacy,a=!!c.analyticsProcessingAllowed(),r=c.getRegion?c.getRegion():'';settle(a&&regionUS(r),{analytics:a,region:r,qa});}
          catch{settle(false,{error:'consent api'});}};
        try{
          if(win.Shopify&&win.Shopify.customerPrivacy&&win.Shopify.customerPrivacy.analyticsProcessingAllowed)ask();
          else if(!win.Shopify||!win.Shopify.loadFeatures)settle(false,{error:'no consent api'});
          else{win.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],err=>err?(done=true,settle(false,{error:'consent api'})):ask());
            win.setTimeout(()=>{if(!done){done=true;settle(false,{error:'consent api timeout'});}},5000);}
        }catch{settle(false,{error:'consent api'});}
      }
    }
    if(state==='off'&&!(cfg&&cfg.url))note('gate',{decision:'off',why:'setting off'});

    // Tray id: random, new when a tray starts; replaced on Start over / Switch back to 3; restored trays keep it.
    const tray={
      id(){const t=get('localStorage',TRAY_KEY);return t&&typeof t.id==='string'?t.id:null;},
      start(){const id=uuid(win.crypto);if(state!=='off')put('localStorage',TRAY_KEY,{id});return id;},
      clear(){try{win.localStorage.removeItem(TRAY_KEY);}catch{}},
      ensure(){return tray.id()||tray.start();}
    };
    // once(key): true the first time for this visit id (e.g. 'ready:<tray>', 'checkout:<tray>').
    function once(key){
      if(state==='off')return false;
      const v=get('localStorage',VISIT_KEY),visit=v&&v.id||'none',s=get('localStorage',ONCE_KEY);
      const keys=s&&s.visit===visit&&Array.isArray(s.keys)?s.keys:[];
      if(keys.includes(key))return false;
      keys.push(key);put('localStorage',ONCE_KEY,{visit,keys:keys.slice(-200)});return true;
    }
    const api={send,tray,once,log,classifyEntry:(ref,opts)=>classifyEntry(ref,win.location.host,opts),state:()=>state};
    win.BG_METRICS=api;
    queued.forEach(([e,f])=>send(e,f));

    if(cfg&&cfg.url&&product&&product.handle)
      send('pdp_viewed',{product:product.handle,page_type:'product',entry:classifyEntry(doc.referrer,win.location.host,{page:'pdp'})});
  }

  return {utmBucket,loadBucket,failClass,classifyEntry,clean,visitFor,regionUS,uuid,boot,VISIT_MS,MAX_SEQ};
});
